module.exports = __webpack_public_path__ + "static/media/facebook.89f104cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/facebook.svg
// module id = 504
// module chunks = 0